import { getLocale } from '@nobia/zeus-components/lib/i18n'
import { polyfillIntl } from '@nobia/zeus-components/lib/polyfills'
import settings from '@nobia/zeus-components/lib/settings'

const { locale } = getLocale(settings.brand)
polyfillIntl(locale)
